import { Link } from '@onyx/ui/components/colleague/link';

import { TopBar } from '../header/top-bar/top-bar';
import utils from '../utils/utils.module.css';
import styles from './error-template.module.css';

type ErrorTemplateProps = {
  headerTitle: string;
  pageTitle: string;
  children?: React.ReactNode;
};

export default function ErrorTemplate({
  headerTitle,
  pageTitle,
  children,
}: ErrorTemplateProps) {
  return (
    <div>
      <TopBar title={headerTitle} hasBackButton backRoute="/" />
      <div className={utils.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>{pageTitle}</h2>
          <div className={styles.description}>{children}</div>
          <Link href="/" hasChevron={false}>
            Return to homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
